export default "__VITE_ASSET__aa7bcbdf__"